import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
// users
import user1 from "../../../assets/images/users/user-1.jpg"
import {
  ProfileModal,
  ResetPasswordModal,
  LogoutModal,
} from "components/Modals"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const [username, setusername] = useState("Admin")
  const [profileModal, setprofileModal] = useState(false)
  const [resetPasswordModal, setResetPasswordModal] = useState(false)
  const [logoutModal, setLogoutModal] = useState(false)
  const profileModalToggle = () => setprofileModal(!profileModal)
  const resetPasswordModalToggle = () =>
    setResetPasswordModal(!resetPasswordModal)
  const logoutModalToggle = () => setLogoutModal(!logoutModal)

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
        </DropdownToggle>
        <DropdownMenu
          className="dropdown-menu-end"
          style={{ color: "#015eb4" }}
        >
          <DropdownItem tag="span" onClick={() => profileModalToggle()}>
            {" "}
            <i
              style={{ color: "#015eb4" }}
              className="mdi mdi-account-circle font-size-17 align-middle me-1"
            />
            {props.t("Profile")}
          </DropdownItem>
          <DropdownItem tag="span" onClick={() => resetPasswordModalToggle()}>
            <i
              style={{ color: "#015eb4" }}
              className="mdi mdi-restart font-size-17 align-middle me-1"
            />
            {props.t("Reset Password")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <span className="dropdown-item" onClick={() => logoutModalToggle()}>
            <i
              style={{ color: "#015eb4" }}
              className="mdi mdi-power font-size-17 align-middle me-1"
            />
            <span>{props.t("Logout")}</span>
          </span>
        </DropdownMenu>
      </Dropdown>
      {/* MODALS */}
      <ProfileModal modal={profileModal} toggle={profileModalToggle} />
      <ResetPasswordModal modal={resetPasswordModal} toggle={resetPasswordModalToggle} />
      <LogoutModal modal={logoutModal} toggle={logoutModalToggle} />
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
